<template>
    <div>
        <div v-if="requires_niscc == 1 && requires_nmc == 0">
            <h2 class="title is-size-4">NISCC Skills Sheet</h2>
            <div class="notification is-warning" v-if="loading_niscc==true">Loading NISCC skills sheet ... </div>
            <div class="notification is-info" v-if="loading_niscc==false && niscc_skills_sheet_categories.length == 0">There are no NISCC skills sheet details to show. </div>
            <table class="table  is-hoverable is-fullwidth" >
                <tbody>
                <template v-for=" row in niscc_skills_sheet_categories " >
                    <tr :key="'title' + row.id">
                        <th colspan="2">{{ row.name}}</th>
                    </tr>
                    <tr v-for="question in row.questions " :key="'question' + question.id">
                        <td>{{ question.name}}</td>
                        <td width="25%"><button class="button is-small" :class="{'is-success' : question.answer == 1}" :disabled="working==true" >Yes</button>
                            <button class="button is-small " :class="{'is-danger' : question.answer == 0}" :disabled="working==true" >No</button></td>
                    </tr>
                    
                </template>
                
            </tbody>
            </table>
            <hr />
        </div>

        <div v-if="requires_nmc == 1">
            <h2 class="title is-size-4">Competency Self Assessment</h2>
            <ol style="margin-left:40px" class="pb-4">
                <li>Familiar with the procedure and can perform</li>
                <li>Familiar with the procedure but need supervision</li>
                <li>Understand the theory of the procedure but never task</li>
                <li>No knowledge of the procedure</li>
            </ol>
            <div class="notification is-warning" v-if="loading_nmc==true">Loading NMC skills sheet ... </div>
            <div class="notification is-info" v-if="loading_nmc==false && nmc_skills_sheet_categories.length == 0">There are no NMC skills sheet details to show. </div>
            <table class="table  is-hoverable is-fullwidth" >
                <tbody>
                <template v-for=" row in nmc_skills_sheet_categories " >
                    <tr :key="'title' + row.id">
                        <th colspan="2">{{ row.name}}</th>
                    </tr>
                    <tr v-for="question in row.questions " :key="'question' + question.id">
                        <td>{{ question.name}}</td>
                        <td width="25%">
                            <button class="button is-small" :class="{'is-success' : question.answer == 1}" :disabled="working==true" >1</button>
                            <button class="button is-small " :class="{'is-warning' : question.answer == 2}" :disabled="working==true" >2</button>
                            <button class="button is-small " :class="{'is-warning' : question.answer == 3}" :disabled="working==true" >3</button>
                            <button class="button is-small " :class="{'is-danger' : question.answer == 4}" :disabled="working==true" >4</button>
                        </td>
                    </tr>
                    
                </template>
                
            </tbody>
            </table>
            <hr />
        </div>

        <div v-if="requires_cop == 1">
            <h2 class="title is-size-4">Paramedic Skills Sheet</h2>
            <div class="notification is-warning" v-if="loading_paramedic==true">Loading Paramedic skills sheet ... </div>
            <div class="notification is-info" v-if="loading_paramedic==false && paramedic_skills_sheet_categories.length == 0">There are no Paramedic skills sheet details to show. </div>
            <table class="table  is-hoverable is-fullwidth" >
                <tbody>
                <template v-for=" row in paramedic_skills_sheet_categories " >
                    <tr :key="'title' + row.id">
                        <th colspan="2">{{ row.name}}</th>
                    </tr>
                    <tr v-for="question in row.questions " :key="'question' + question.id">
                        <td>{{ question.name}}</td>
                        <td width="25%">
                            <button class="button is-small" :class="{'is-success' : question.answer == 1}" :disabled="working==true" >1</button>
                            <button class="button is-small " :class="{'is-warning' : question.answer == 2}" :disabled="working==true" >2</button>
                            <button class="button is-small " :class="{'is-warning' : question.answer == 3}" :disabled="working==true" >3</button>
                            <button class="button is-small " :class="{'is-danger' : question.answer == 4}" :disabled="working==true" >4</button>
                        </td>
                    </tr>
                    
                </template>
                
            </tbody>
            </table>
         </div>

         <div v-if="hasGrade27 == true">
            <h2 class="title is-size-4">Social Work Skills Sheet</h2>
            <div class="notification is-warning" v-if="loading_social_work==true">Loading Social Work skills sheet ... </div>
            <div class="notification is-info" v-if="loading_social_work==false && social_work_skills_sheet_categories.length == 0">There are no Social Work skills sheet details to show. </div>
            <table class="table  is-hoverable is-fullwidth" >
                <tbody>
                <template v-for=" row in social_work_skills_sheet_categories " >
                    <tr :key="'title' + row.id">
                        <th colspan="2">{{ row.name}}</th>
                    </tr>
                    <tr v-for="question in row.questions " :key="'question' + question.id">
                        <td>{{ question.name}}</td>
                        <td width="25%">
                            <button class="button is-small" :class="{'is-success' : question.answer == 1}" :disabled="working==true" >Yes</button>
                            <button class="button is-small " :class="{'is-warning' : question.answer == 2}" :disabled="working==true" >No</button>
                            
                        </td>
                    </tr>
                    
                </template>
                
            </tbody>
            </table>
         </div>

    </div>
</template>

<script>
import MemberMixin from '@/mixins/MemberMixin.js';

import MemberService from '@/services/MemberService.js';
import UtilityService from '@/services/UtilityService.js';

export default {
    name: 'Education',
  data() {
    return {
        loading_niscc: true,
        loading_nmc: true,
      loading_paramedic: true,
      loading_social_work:true,
      working: false,
      niscc_skills_sheet_categories: [],
      nmc_skills_sheet_categories: [],
      paramedic_skills_sheet_categories: [],
      social_work_skills_sheet_categories: [],
      member_grades: []
    }
  },
  mixins: [MemberMixin],
  props: ['member_id', 'requires_cop', 'requires_niscc', 'requires_nmc'],
  methods: {
        
       
        async getNisccMemberSkillsSheet() {
            if(this.requires_niscc == 1)
            {
                this.loading_niscc=true
                UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id + "/skills_sheets?niscc_only=1")
                .then(
                    (skills_sheet_categories => {
                        this.$set(this, "niscc_skills_sheet_categories", skills_sheet_categories);
                        this.loading_niscc=false
                    }).bind(this)
                );
            }
        },
        async getNurseMemberSkillsSheet() {
            if(this.requires_nmc == 1)
            {
                this.loading_nmc=true
                UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id + "/skills_sheets?nmc_only=1")
                .then(
                    (skills_sheet_categories => {
                        this.$set(this, "nmc_skills_sheet_categories", skills_sheet_categories);
                        this.loading_nmc=false
                    }).bind(this)
                );
            }
        },
        async getParamedicMemberSkillsSheet() {
            if(this.requires_cop == 1)
            {
                this.loading_paramedic=true
                UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id + "/skills_sheets?paramedic_only=1")
                .then(
                    (skills_sheet_categories => {
                        this.$set(this, "paramedic_skills_sheet_categories", skills_sheet_categories);
                        this.loading_paramedic=false
                    }).bind(this)
                );
            }
        },
        async getSocialWorkMemberSkillsSheet() {
            //if(this.hasGrade27 == true)
           // {
                this.loading_social_work=true
                UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id + "/skills_sheets?social_work_only=1")
                .then(
                    (skills_sheet_categories => {
                        this.$set(this, "social_work_skills_sheet_categories", skills_sheet_categories);
                        this.loading_social_work=false
                    }).bind(this)
                );
            //}
        },
        async getMemberGrades() {
            
            this.grade_id = '';
            this.remove_grade_id = '';

                MemberService.getMemberGrades(this.accessToken, this.member_id)
                .then(
                    (member_grades => {
                        this.$set(this, "member_grades", member_grades);
                        
                    }).bind(this)
                );
            
        },
      
        
    },
    created() {
            this.getAccessToken()
            .then(() => { 
                
                this.getNisccMemberSkillsSheet()
                this.getNurseMemberSkillsSheet()
                this.getParamedicMemberSkillsSheet()
                this.getMemberGrades().then(() => {
                    this.getSocialWorkMemberSkillsSheet()
                })
                
            });
        
    },
    computed : {
        hasGrade27() {
        return Object.values(this.member_grades).some(
            grade => grade.grade_id === 27
        );
        }
    }
}
</script>